export const POINT_GEOMETRY = "Point"
export const MULTIPOINT_GEOMETRY = "MultiPoint"

export const geoJSONPointTypes = [POINT_GEOMETRY, MULTIPOINT_GEOMETRY]
